import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Firebase web yapılandırması public'tir; güvenlik Firestore kuralları ile sağlanır (firestore.rules).
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCUwL0msHYG25-KM-EPxXqAlpJPqg8wj-w",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "evren-otogaz.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "evren-otogaz",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "evren-otogaz.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID || "705079623296",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:705079623296:web:291101e00fc74289f67065",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
